<template>
    <v-dialog :model-value="show" max-width="700px" persistent>
        <v-card>
            <v-card-title class="text-h5 pl-6 pt-6">New Exclusion Area</v-card-title>
            <v-card-text>
                <v-form ref="form">
                    <v-row>
                    <v-col cols="12" dense>
                        <v-text-field 
                            label="Area Name" 
                            v-model="area.name"
                            variant="outlined"
                            density="comfortable"
                            :rules="[rules.required]"
                            required />
                    </v-col>
                    </v-row>
                    <v-row dense>
                    <v-col cols="4">
                        <v-text-field 
                            label="Radius (m)" 
                            v-model="area.radius" 
                            type="number" 
                            variant="outlined"
                            density="comfortable"
                            :rules="[rules.required, rules.number, rules.positive]"
                            required />
                    </v-col>
                    <v-col cols="4">
                        <v-text-field 
                        label="Longitude" 
                        v-model="area.center[0]" 
                        variant="outlined"
                        density="comfortable"
                        :rules="[rules.required, rules.number]"
                        required />
                    </v-col>
                    <v-col cols="4">
                        <v-text-field 
                        label="Latitude" 
                        v-model="area.center[1]" 
                        variant="outlined"
                        density="comfortable"
                        :rules="[rules.required, rules.number]"
                        required />
                    </v-col>
                    </v-row>
                    
                    <v-btn
                        variant="plain"
                        color="primary"
                        class="pa-0 pb-10 text-decoration-underline text-body-2 text-normal-case"
                        @click="$emit('pick-coordinates')"
                    >
                        Pick coordinates on map
                    </v-btn>
                    <v-textarea 
                        label="Description" 
                        v-model="area.description" 
                        rows="2" 
                        variant="outlined"
                        density="comfortable"
                        required/>
                    <v-row justify="space-between" dense>
                        <v-col cols="auto">
                            <v-tooltip location="top">
                            <template #activator="{ props }">
                                <div v-bind="props">
                                    <v-checkbox v-model="area.active" label="Enable" style="margin-top: -10px;"/>
                                </div>
                            </template>
                            <span>Uncheck to disable this area upon creation.</span>
                        </v-tooltip>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn variant="plain" @click="clearForm">Clear</v-btn>
                        </v-col>
                    
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="$emit('close')">Cancel</v-btn>
                <v-btn color="green" @click="submitForm">Submit</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>
<script>

export default {
    name: 'ExclusionAreaFormDialog',
    props:{
        show: {
            type: Boolean,
            default: false
        },
        info: {
            type: Object,
        }
    },
    data(){
        return {
            area:{
                name: '',
                radius: 0,
                center: [0.0,0.0],
                description: '',
                active: true,
            },
            rules: {
                required: value => !!value || 'Can not be empty',
                number: v => !isNaN(v) || 'Must be a number',
                positive: v => v >= 0 || 'Must be a positive number'
            },
        };
    },
    methods:{
        clearForm(){
            this.area = {
                name: '',
                radius: 0,
                center: [0.0, 0.0],
                description: '',
                active: true,
            };
        },
        async submitForm(){
            const valid = await this.$refs.form?.validate();
            if (valid.valid) {
                this.$emit('submit', this.area);
                this.clearForm();
            }else{
                this.$emit('error');
            }
        }
    },
    watch:{
        info: {
            immediate: true,
            handler(newInfo) {
                if (newInfo) {
                    this.area.radius = newInfo.radius || this.area.radius
                    this.area.center = newInfo.center || this.area.center;
                }
            }
        }
    }
}
</script>